import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { NgxEventCalendarModule } from 'ngx-event-calendar';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CirculationCalendarComponent } from '../circulations/circulation-calendar/circulation-calendar.component';
import { CirculationsModule } from '../circulations/circulations.module';

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    SharedModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    FlexLayoutModule,
    NgxEventCalendarModule,
    BrowserModule,
    FormsModule,
    NgxEventCalendarModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatNativeDateModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    BrowserAnimationsModule,
    CirculationsModule
  ],
})
export class DashboardModule {}
